import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
type PropertyInfoProps = {
  title: string;
  value: ReactNode;
};
export const PropertyInfo = ({ title, value }: PropertyInfoProps) => {
  return (
    <Stack>
      <Typography
        variant="body2"
        sx={{
          opacity: 0.7,
          textTransform: "capitalize",
        }}
        fontWeight={(theme) => theme.typography.fontWeightMedium}
      >
        {title}
      </Typography>
      <Typography sx={{ whiteSpace: "pre-wrap" }}>{value}</Typography>
    </Stack>
  );
};
